export default __webpack_public_path__ + "static/media/arkit.c133da9a.png";